import(/* webpackMode: "eager", webpackExports: ["AccountMenu"] */ "/opt/buildhome/repo/components/breach/account.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResumeButton"] */ "/opt/buildhome/repo/components/breach/resume-button.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
